module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABXElEQVQ4jZXTP2hTURQG8F/Cs4hadFBKQ4c6tA7WpWCnDKVCcVAKuuoiHapO7SIIQtGOrk5dxFBKFIIZnAKKqHsGHZrFyUEillL8hyY63Pvow+bFeJb77nnf951zz59Co9HQx17jEKbzAMU+5A0Mo4NaHiiJ522cxi4+YgrncTj+30YdTYzgCLZwr4gh3MJ3/MBkJI1mApXwC6ci5ncMeiDBT7zDGt7nZPoNlzP3kzHjTjGqdf8C/MvmY0bdtIgfcPY/BGbwib0uVKNzUCujkhWoCcW8MQB5ESewmRWAm3iA433IR7GO66kjK/BUaGcbZ3qQJ/BZ6FY1daaDVMIcnuErnuA5VoU2r+IiVoTnXsIrtBPcxTW0hDo0sYTl+A1vcQUX8FiYi/t4lAgVvYoXEVzBQ4xH8JjQ9zf4gllhGs/hTiFnG+sxyg4OxrOsx1bmbeMCXuJYrFMrCuyzP92xS4DXFct/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/apps/18.png
// module id = eZ/u
// module chunks = 0